import ViewProviderBotContainer from './view-provider-bot-container';

export default ViewProviderBotContainer;
